import { useQuery } from "@apollo/client";
import { GetOrderDesignsByOrderIdDocument } from "../../gql/generated/graphql";
import { useMemo } from "react";
import { type OrderDesign } from "@jasper/client-models";
import { formatOrderDesign } from "./utils";

interface UseOrderDesignsListProps {
  orderId: string;
}

interface UseOrderDesignsListHookResult {
  orderDesigns: OrderDesign[];
  isLoading: boolean;
  error?: Error;
}

export const useOrderDesignsList = ({
  orderId,
}: UseOrderDesignsListProps): UseOrderDesignsListHookResult => {
  const { data, loading, error } = useQuery(GetOrderDesignsByOrderIdDocument, {
    variables: { orderId },
  });

  return {
    isLoading: loading,
    error,
    orderDesigns: useMemo(() => {
      const orderDesigns = data?.getOrderDesignsByOrderId ?? [];
      return orderDesigns
        .map(formatOrderDesign)
        .filter((od): od is OrderDesign => od !== null);
    }, [data]),
  };
};
